import { render, staticRenderFns } from "./playerarea.vue?vue&type=template&id=94047332&scoped=true"
import script from "./playerarea.vue?vue&type=script&lang=js"
export * from "./playerarea.vue?vue&type=script&lang=js"
import style0 from "./playerarea.vue?vue&type=style&index=0&id=94047332&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94047332",
  null
  
)

export default component.exports